import Layout from '../components/Layout'
import ContactForm from "../components/ContactForm";
import Locations from "../components/Locations";

export default function Docs() {
    return (
        <Layout title="Contact">
            <ContactForm />
            <Locations />
        </Layout>
    )
}